import React from "react"


const SnipcartButtonIndivItem = props => {
  return (
    <button
    className="snipcart-add-item button__indivItemPage"
    data-item-id={props.id}
    data-item-price={props.price}
    data-item-url={`https://galinihealth.com${props.link}`}
    data-item-description={props.description}
    data-item-image={props.imagesrc}
    data-item-name={props.name}
  >
    {props.buttonText}
  </button>
  )
}

export default SnipcartButtonIndivItem